<div class="job-list w-100 d-inline-block custom-scroller">

    <mat-card class="mat-elevation-z0" *ngIf="jobList && jobList.length == 0">No jobs found!</mat-card>

    <div class="job float-start w-100 d-flex flex-column flex-xl-row align-items-start align-items-xl-center mb-3 cursor-pointer"
        *ngFor="let job of jobList" (click)="rowClicked(job)">
        <div class="icon-details float-start d-flex align-items-center col-12 col-xl-3 mb-3 mb-xl-0 pb-3 pb-xl-0">
            <div class="icon float-start ps-2 col-2 col-xl-3 text-center">
                <span class="icon-Default icon-{{job.serviceType.replace(' ','' )}}"></span>
            </div>
            <div class="details float-start px-2 col-10 col-xl-9">
                <h5>{{job.name}}</h5>
                <h5 class="cursor-pointer">#{{job.jobNumber}}</h5>
                <a class="cursor-pointer">{{job.address}}</a>
            </div>
        </div>
        <div class="tags-worker float-start d-flex align-items-center col-12 col-xl-3 mb-3 mb-xl-0 pb-3 pb-xl-0">
            <div class="tags float-start px-2">
                <div class="common-tag yellow float-start me-2 font-10">{{job.statusDisplay}}</div>
                <div class="common-tag light-gray float-start me-2 font-10">{{job.jobOrigin}}</div>
                <div class="common-tag light-gray float-start me-2 font-10" *ngIf="job?.issueReportedType!=null">{{job.issueReportedType}}</div>
                <div class="common-tag yellow float-start me-2 font-10"
                    *ngIf="job.workflowStatusId === workflowStatesEnum.JobPendingReview && (job.shouldCharge || job.readyForMonthlyPayment)">
                    Pending Payment
                </div>
                <div class="common-tag yellow float-start me-2 font-10" *ngIf="job.isSnoozedJob"> Job Snoozed </div>
            </div>
        </div>
        <div class="assigners float-start d-flex align-items-center col-12 col-xl-4 mb-3 mb-xl-0 pb-3 pb-xl-0">
            <div class="assigned float-start px-2 col-6">
                <h6>{{job.serviceType}}
                    <span *ngIf="job.urgency==1">| <span class="urgent"> Urgent</span></span>
                    <span *ngIf="job.urgency==-1">| <span class="common-tag dark-red float-none font-10">
                            Emergency</span></span>
                </h6>

                <p *ngIf="job.isActive && job.workflowStatusId !== workflowStatesEnum.JobDrafted">Posted on
                    {{job.postedOn| date:'dd/MM/yyyy'}} {{job.postedOn| date:'hh:mm a'}}</p>
            </div>
            <div class="assigned float-start px-4 col-3">
                <div
                    *ngIf="showAssignSP(job)">
                    <h6>
                        Assigned SP</h6>
                    <h6 class="word-break-all">{{job.serviceProviderName}}</h6>
                </div>
                <div
                    *ngIf="showInvitedSP(job)">
                    <h6>
                        Invited SP</h6>
                    <h6 class="word-break-all invited-trades-main">
                        {{job.serviceProviderName?.split(' | ').length > 1 ?
                        job.serviceProviderName?.split(' | ')[0]+'...':job.serviceProviderName?.split(' | ')[0] }}
                        <div class="invited-trades-tooltip">
                            <h6 class="font-13">Invited Trades</h6>
                            <p class="font-poppins font-12 font-regular">{{job.serviceProviderName}}</p>
                        </div>
                    </h6>
                </div>
            </div>
            <div class="assigned float-start px-4 col-3">
                <h6>Assigned PM</h6>
                <h6 *ngIf="job.assignedPM" class="word-break-all">
                    <ng-container *ngFor="let name of splitAssignedPM(job.assignedPM)">
                      {{ name }}<br>
                    </ng-container>
                  </h6>
                <!-- <h6 *ngIf="job.assignedPM && job?.assignedPM?.length>0"  class="word-break-all">{{job.assignedPM}}</h6> -->
            </div>
        </div>
        <div class="progresser col-12 col-xl-2 d-flex align-items-center justify-content-start">
            <div class="assigned w-100">
                <app-dead-line *ngIf="(job.deadline)" [postedDate]="job.postedDate" [dueDate]="getJobDueDate(job)"
                    [description]="getJobDueDateDescription(job)"
                    [defaultTimeZoneDiffMinutes]="job.defaultTimeZoneDiffMinutes">
                </app-dead-line>
            </div>
        </div>
    </div>

</div>